import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '../../../node_modules/@angular/common/http';
import { LoaderService } from './loader.service';
import { Observable } from '../../../node_modules/rxjs';

@Injectable()
export class LoaderInterceptorService {

  private requests: HttpRequest<any>[] = [];

 constructor(private loaderService: LoaderService) { }

 removeRequest(req: HttpRequest<any>) {
   const i = this.requests.indexOf(req);
   if (i >= 0) {
     this.requests.splice(i, 1);
   }
   this.loaderService.isLoading.next(this.requests.length > 0);
 }

 intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
   this.requests.push(req);
   this.loaderService.isLoading.next(true);
   // We create a new observable which we return instead of the original
   return Observable.create(observer => {
     // And subscribe to the original observable to ensure the HttpRequest is made
     const subscription = next.handle(req)
       .subscribe(
       event => {
         if (event instanceof HttpResponse) {
           this.removeRequest(req);
           observer.next(event);
         }
       },
       err => { this.removeRequest(req); observer.error(err); },
       () => { this.removeRequest(req); observer.complete(); });
     // return teardown logic in case of cancelled requests
     return () => {
       this.removeRequest(req);
       subscription.unsubscribe();
     };
   });
 }

}



// WEBPACK FOOTER //
// ./src/app/services/loader-interceptor.service.ts